import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  Card,
  CardHeader,
  Button,
  Grid,
  withWidth,
  List,
  ListItemText,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Container, InputText, Loading } from "src/components";
import { Save as SaveIcon } from "@material-ui/icons";

import { alterar_senha, alterar_usuario } from "src/store/actions/usuario";
import theme from "src/theme";

function Perfil() {
  const { loading, usuario, empresas } = useSelector((state) => state.usuario);
  const [formUsuario, setFormUsuario] = useState(usuario);
  const [formSenha, setFormSenha] = useState({
    password: "",
    repeatedPassword: "",
  });

  const handleSubmitUsuario = () => {
    alterar_usuario(formUsuario);
  };

  const handleSubmitSenha = async () => {
    try {
      await alterar_senha(formSenha);
      alert('Senha modificada com sucesso.!')
    } catch (error) {
      alert('Ooops, parece que aconteceu um erro, verifique os dados e tente novamente.')
    }
  };

  const handleChange = (event) => {
    setFormUsuario({
      ...formUsuario,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangePass = (event) => {
    setFormSenha({
      ...formSenha,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Container title="Editar perfil">
      <Loading loading={loading} />
      <Grid container spacing={2}>
        <Grid container spacing={3} item md={6}>
          <Grid item md={12}>
            <Card>
              <ValidatorForm
                style={{
                  width: "98%",
                  margin: "0 auto",
                  paddingBottom: "16px",
                }}
                onSubmit={handleSubmitUsuario}
              >
                <CardHeader
                  title="Dados do usuário"
                  action={
                    <Button
                      style={{
                        background: theme.palette.primary.main,
                        color: theme.palette.common.white,
                      }}
                      type="submit"
                    >
                      <SaveIcon /> Salvar
                    </Button>
                  }
                />
                <Grid spacing={2} container>
                  <Grid item md={6}>
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      name="nome"
                      label="Nome"
                      value={formUsuario.nome}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      name="email"
                      label="Email"
                      value={formUsuario.email}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Card>
          </Grid>
          <Grid item md={12}>
            <Card>
              <ValidatorForm
                style={{
                  width: "98%",
                  margin: "0 auto",
                  paddingBottom: "16px",
                }}
                onSubmit={handleSubmitSenha}
              >
                <CardHeader
                  title="Alterar senha"
                  action={
                    <Button
                      style={{
                        background: theme.palette.primary.main,
                        color: theme.palette.common.white,
                      }}
                      type="submit"
                    >
                      <SaveIcon /> Salvar
                    </Button>
                  }
                />
                <Grid spacing={2} container>
                  <Grid item md={6}>
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      name="password"
                      label="Nova senha"
                      value={formSenha.password}
                      onChange={handleChangePass}
                      type="password"
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      name="repeatedPassword"
                      label="Senha atual"
                      value={formSenha.repeatedPassword}
                      onChange={handleChangePass}
                      type="password"
                    />
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Card>
          </Grid>
        </Grid>
        <Grid container item md={6}>
          <Card style={{ width: "100%" }}>
            <CardHeader title="Empresas" />
            <List style={{ width: "98%", margin: "0 auto" }}>
              {empresas.map((empresa) => (
                <ListItemText key={empresa.id}> - {empresa.nome} </ListItemText>
              ))}
            </List>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withWidth()(Perfil);
